// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <svg width="200" height="35" viewBox="0 0 200 35" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Apartman Yönetim Sistemi">
      <path d="M4 9L9.5 4L15 9H4Z" fill={theme.vars.palette.primary.dark} />
      <rect x="4" y="9" width="11" height="22" rx="1" fill={theme.vars.palette.primary.main} />
      <rect x="15" y="14" width="7" height="17" rx="1" fill={theme.vars.palette.primary.light} />
      <g fill={theme.vars.palette.common.white}>
        <rect x="6" y="12" width="2.2" height="2.2" rx="0.4" />
        <rect x="10.2" y="12" width="2.2" height="2.2" rx="0.4" />
        <rect x="6" y="17" width="2.2" height="2.2" rx="0.4" />
        <rect x="10.2" y="17" width="2.2" height="2.2" rx="0.4" />
        <rect x="6" y="22" width="2.2" height="2.2" rx="0.4" />
        <rect x="10.2" y="22" width="2.2" height="2.2" rx="0.4" />
        <rect x="16.7" y="17" width="1.8" height="1.8" rx="0.3" />
        <rect x="19.8" y="17" width="1.8" height="1.8" rx="0.3" />
        <rect x="16.7" y="21.3" width="1.8" height="1.8" rx="0.3" />
        <rect x="19.8" y="21.3" width="1.8" height="1.8" rx="0.3" />
        <rect x="16.7" y="25.6" width="1.8" height="1.8" rx="0.3" />
        <rect x="19.8" y="25.6" width="1.8" height="1.8" rx="0.3" />
      </g>
      <text
        x="31"
        y="23"
        fontFamily={theme.typography.fontFamily}
        fontSize="17"
        fontWeight="700"
        fill={theme.vars.palette.text.primary}
        textLength="165"
        lengthAdjust="spacingAndGlyphs"
      >
        Apartman Yönetim
      </text>
    </svg>
  );
}
